
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 4h.625l1.063 2.125c1.277.14 2.567.598 3.531 1.719C23.357 9.166 24 11.176 24 14v.906c.571.546 1 1.247 1 2.094 0 1.26-.891 2.154-2 2.594a39.003 39.003 0 01-1.25 3.438c-.487 1.141-.894 2.047-1.5 2.688a7.19 7.19 0 01-10.5 0c-.606-.64-1.045-1.547-1.531-2.688-.446-1.045-.849-2.27-1.219-3.438C5.891 19.155 5 18.26 5 17c0-.851.428-1.549 1-2.094V14c0-3.042.821-5.612 2.688-7.375S13.335 4 17.001 4zm-.594 2.063c-2.973.1-5.062.789-6.344 2-1.378 1.302-2.063 3.241-2.063 5.938v1.844l-.5.281a.997.997 0 00-.5.875c0 .534.384.957.906 1l.688.031.188.656c.37 1.203.831 2.474 1.281 3.531s.967 1.957 1.125 2.125c2.128 2.252 5.497 2.252 7.625 0 .158-.168.674-1.068 1.125-2.125s.911-2.328 1.281-3.531l.188-.656.688-.031a.98.98 0 00.906-1 .995.995 0 00-.5-.875l-.5-.281v-1.844c0-2.518-.587-4.001-1.313-4.844a3.19 3.19 0 00-1.188-.875c.024.149.058.291.063.438.019.67-.279 1.354-.75 1.75-.941.792-2.05.727-3.125.781s-2.174.128-2.813.375-.867.389-.875 1.375h-2c.013-1.623 1.015-2.808 2.156-3.25s2.365-.416 3.406-.469 1.882-.271 1.969-.344c.043-.037.037.047.031-.156s-.135-.677-.469-1.344zM12 16a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    